module.exports = {
      id: "icon-email-envelope-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-email-envelope",
      toString: function () {
        return this.url;
      }
    }